// 首页
import Axios from "@/assets/js/ajax";
import axios from "axios";
import {
  getBannerUrl,
  hotUsersUrl,
  rankCoursesUrl,
  getVersionUrl,
} from "@/assets/js/const";
const state = {
  user: {}, // 用户信息 初始化一个对象
  bannerList: [], // 轮播图列表
  hotUsers: [], // 热门用户
  rankCourses: [], // 课程点赞排行榜
};

const getters = {
  bannerList: (state) => state.bannerList,
  user: (state) => state.user,
  hotUsers: (state) => state.hotUsers,
  rankCourses: (state) => state.rankCourses,
};

const mutations = {
  setBannerList(state, payload) {
    state.bannerList = payload;
  },
  setUser(state, payload) {
    state.user = payload;
  },
  setHotUsers(state, payload) {
    state.hotUsers = payload;
  },
  setRankCourses(state, payload) {
    state.rankCourses = payload;
  },
};

const actions = {
  async initApp({ commit }) {
    let { data } = await Axios.get(getBannerUrl);
    commit("setBannerList", data.data.banner);
    commit("setUser", data.data.user);
    try {
      gio("setUserId", data.data.user.uid);
      gio("people.set", {
        user_name_ppl: data.data.user.name,
        user_position_ppl: data.data.user.jobTitle,
        user_department_ppl: data.data.user.department,
      });
    } catch (error) {}
    if (data.data.user) {
      sessionStorage.setItem(
        "userMess",
        JSON.stringify({
          dept: data.data.user.department,
          nickname: data.data.user.name,
          job: data.data.user.jobTitle,
          userId: data.data.user.uid,
        })
      );
    }
  },
  async getHotUsers({ commit }) {
    let { data } = await Axios.get(hotUsersUrl);
    commit("setHotUsers", data.data);
  },
  async getRankCourses({ commit }) {
    let { data } = await Axios.get(rankCoursesUrl);
    commit("setRankCourses", data.data);
  },
  async getVersion() {
    let { data } = await axios.get(getVersionUrl, {
      withCredentials: false,
    });
    return data.data[0];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
